import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { gql } from '@apollo/client';
import apolloClient from '../../graphql/apollo-client';
import { CREATE_INQUIRY } from '../../graphql/mutations';
import { toast } from 'react-hot-toast';

const InquiryCreatePage: React.FC = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async () => {
    if (!title.trim() || !content.trim()) return;
    setSaving(true);
    try {
      const res = await apolloClient.mutate({
        mutation: gql`${CREATE_INQUIRY}`,
        variables: { input: { title, content } },
      });
      if (res.data?.createInquiry?.success) {
        toast.success(t('inquiry.created'));
        navigate('/inquiry');
      } else {
        toast.error(res.data?.createInquiry?.error || t('errorOccurred'));
      }
    } catch (err: any) {
      toast.error(err.message || t('errorOccurred'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto px-4 py-6">
      <h1 className="text-xl font-bold text-gray-900 mb-2">{t('inquiry.title')}</h1>
      <hr className="border-gray-200 mb-6" />

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">{t('inquiry.titleLabel')}</label>
          <input type="text" value={title} onChange={e => setTitle(e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-1 focus:outline-none focus:ring-blue-500"
            placeholder={t('inquiry.titlePlaceholder')} />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">{t('inquiry.contentLabel')}</label>
          <textarea value={content} onChange={e => setContent(e.target.value)} rows={8}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-1 focus:outline-none focus:ring-blue-500"
            placeholder={t('inquiry.contentPlaceholder')} />
        </div>
      </div>

      <hr className="border-gray-200 my-6" />
      <div className="flex justify-end gap-3">
        <button onClick={() => navigate('/inquiry')}
          className="px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50">
          {t('cancel')}
        </button>
        <button onClick={handleSubmit} disabled={!title.trim() || !content.trim() || saving}
          className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed">
          {saving ? t('saving') : t('inquiry.submit')}
        </button>
      </div>
    </div>
  );
};

export default InquiryCreatePage;
